// imports
import _forEach from "lodash/forEach";
import Config from "$root/Config";

import IncidentModel from "$models/incidents/IncidentModel";
import IncidentCollection from "$collections/incidents/IncidentCollection";
import IncidentCandidateCollection from "$collections/IncidentCandidateCollection";
import PermissionCollection from "$collections/PermissionCollection";
import UsersCollection from "$collections/UsersCollection";
import IncidentMarkerCollection from "$collections/IncidentMarkerCollection";
import ReportIncidentsCollection from "$collections/ReportIncidentsCollection";
import ReportIncidentsDetailCollection from "$collections/ReportIncidentsDetailCollection";
import ReportIncidentsStartCollection from "$collections/ReportIncidentsStartCollection";
import TaxonomyCollection from "../../collections/TaxonomyCollection";
import IncidentTeam from "../../models/incidents/IncidentTeam";

function markReportCollection(collection) {
	collection.reportFetchPending = false;
	return collection;
}

export default {
	namespaced: true,
	state() {
		const c_incidentCategories = new TaxonomyCollection({
			type: "c_incidentCategories",
		});
		const c_incidentCreateCategories = new TaxonomyCollection({
			type: "c_incidentCategories",
			config: { params: { operation: "create" } },
		});
		const c_incidentEditCategories = new TaxonomyCollection({
			type: "c_incidentCategories",
			config: { params: { operation: "edit" } },
		});
		const c_incidentStatuses = new TaxonomyCollection({
			type: "c_incidentStatuses",
		});
		const c_incidentReportTypes = new TaxonomyCollection({
			type: "c_incidentReportTypes",
		});
		const c_incidentTeams = new TaxonomyCollection({
			type: "c_incidentTeams",
			Model: IncidentTeam,
		});
		const c_incidentDeclineReasons = new TaxonomyCollection({
			type: "c_incidentDeclineReasons",
		});
		const c_postalCodes = new TaxonomyCollection({
			type: "c_postalCodes",
		});

		return {
			permissions: new PermissionCollection({
				config: { url: Config.getUrl("permissions") },
			}),

			list: new IncidentCollection(),

			markers: markReportCollection(new IncidentMarkerCollection({
				config: { url: Config.getUrl("incidentMarkers") },
			})),

			candidateList: new IncidentCandidateCollection({
				config: { url: Config.getUrl("c_incidentCandidate") },
			}),

			current: new IncidentModel(),
			selected: new IncidentModel(),

			// Pro taxonomies (old JSON:API keys alias the same instances)
			c_incidentCategories,
			c_incidentCreateCategories,
			c_incidentEditCategories,
			c_incidentStatuses,
			c_incidentReportTypes,
			c_incidentTeams,
			c_incidentDeclineReasons,
			c_postalCodes,
			categories: c_incidentCategories,
			statuses: c_incidentStatuses,
			reportTypes: c_incidentReportTypes,
			teams: c_incidentTeams,
			declineReasons: c_incidentDeclineReasons,
			postcodes: c_postalCodes,

			users: new UsersCollection(),

			reportIncidentsCategories: markReportCollection(new ReportIncidentsCollection({
				config: { url: Config.getUrl("reportIncidentsCategories") },
			})),

			reportIncidentsDetail: markReportCollection(new ReportIncidentsDetailCollection({
				config: { url: Config.getUrl("reportIncidentsDetail") },
			})),

			reportIncidentsStart: markReportCollection(new ReportIncidentsStartCollection({
				config: { url: Config.getUrl("reportIncidentsStart") },
			})),
		};
	},

	mutations: {
		UPDATE_AUTH(state, payload) {
			const authorizationToken = {
				Authorization: payload.jwt_authorization,
			};
			const updated = new Set();

			_forEach(state, (item) => {
				if (!item || updated.has(item) || typeof item.setConfig !== "function") return;
				updated.add(item);
				item.setConfig("headers", authorizationToken);
			});

			// update permission url (unconventional but hey... so is it's endpoint)
			state.permissions.setConfig(
				"url",
				`${Config.getUrl("permissions")}/${payload.user.id}?fields[user--user]=field_user_incident_permissions`,
			);
		},

		ON_LOGOUT(state) {
			const cleared = new Set();
			_forEach(state, (item) => {
				if (!item || cleared.has(item) || typeof item.unsetConfig !== "function") return;
				cleared.add(item);
				item.unsetConfig("headers").clear();
			});
		},
	},
};
